import "core-js/modules/es.object.assign.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CircleBubble from '@/components/common/CircleBubble';
import { viewStats } from '../../utils/Analytics';
import { isProd } from '@/config';
export default {
  name: 'category-list',
  components: {
    CircleBubble: CircleBubble
  },
  props: {
    categoryList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isAbTest: Boolean
  },
  data: function data() {
    return {
      pageCategoryList: [],
      scrollPercent: 0
    };
  },
  mounted: function mounted() {
    var scrollEl = document.getElementById('bubble-wrap-test-scroll-view-stats');
    scrollEl.addEventListener('scroll', window.StatusReportData, false);
    viewStats({
      target: {
        id: 'bubble-wrap-test-scroll-view-stats'
      }
    });
  },
  methods: {
    onScroll: function onScroll(e) {
      if (e && e.target) {
        this.scrollPercent = Math.floor(e.target.scrollLeft / e.target.scrollWidth * 100);
      }
    },
    onCategoryClick: function onCategoryClick(content) {
      var jumpUrl = content.jumpUrl,
        dataSeed = content.dataSeed,
        tagSeed = content.tagSeed;
      if (!jumpUrl) return;
      this.go(jumpUrl, {
        _blank: true
      });
      if (tagSeed) {
        window.lxTagReport('c_movie_aq5xt2v5', dataSeed.bid, Object.assign({}, tagSeed));
      }
      if (dataSeed) {
        window.seedAction(dataSeed);
      }
    }
  }
};